import { useDataValue, useDataIsSubmitting } from 'Simple/Data.js'

export function useIsDisabled(props) {
  let isSubmitting = useDataIsSubmitting({
    context: 'create_claim',
    viewPath: props.viewPath,
  })
  let payment_account = useDataValue({
    context: 'create_claim',
    path: 'payment_account',
    viewPath: props.viewPath,
  })
  let treatment_id = useDataValue({
    context: 'create_claim',
    path: 'treatment_id',
    viewPath: props.viewPath,
  })

  return isSubmitting || !payment_account || !treatment_id
}
